import AxiosBaseService from "./axiosBaseService";
import axios from "axios";


export default class AxiosUserService extends AxiosBaseService {

    google_callback_login(strParams: string) {
    return this.get(
        `${this.serverUrl}/user/auth/google/login/callback?${strParams}`,
        {}
    )
    }

    google_authorize_login(
    userRole: string | null = null,
    learningLanguage: string | null = null,
    siteLanguage: string | null = null,
    redirect: string | null = null
    ) {
    let urlStr: string =
        `${this.serverUrl}/user/auth/google/login/authorize?scopes=email&scopes=profile`;

    if (userRole !== null) {
        urlStr += `&user_role=${encodeURIComponent(userRole)}`;
    }

    if (learningLanguage !== null) {
        urlStr += `&learning_language=${encodeURIComponent(learningLanguage)}`;
    }

    if (siteLanguage !== null) {
        urlStr += `&site_language=${encodeURIComponent(siteLanguage)}`;
    }

    if (redirect !== null) {
        urlStr += `&redirect=${encodeURIComponent(redirect)}`;
    }

    return this.get(urlStr, {});
    }
    google_callback_register(
    strParams: string,
    user_role: string,
    learning_language: string
    ) {
    return this.get(
        `${this.serverUrl}/user/auth/google/${user_role.toLowerCase()}/register/callback?${strParams}&learning_language=${encodeURIComponent(learning_language)}`,
        {}
    )
    }

    google_authorize_register(
    user_role: string,
    learning_language: string,
    siteLanguage: string | null = "English",
    redirect: string | null = null
    ) {
    let urlStr =
        `${this.serverUrl}/user/auth/google/register/authorize?scopes=email&scopes=profile&user_role=${encodeURIComponent(user_role)}&learning_language=${encodeURIComponent(learning_language)}`;

    if (siteLanguage !== null) {
        urlStr += `&site_language=${encodeURIComponent(siteLanguage)}`;
    }

    if (redirect !== null) {
        urlStr += `&redirect=${encodeURIComponent(redirect)}`;
    }

    return this.get(urlStr, {});
    }

    verifyEmail(token: string) {
        return this.post(`${this.serverUrl}/user/verify`, {token}, {}
        )
    }

    requestEmailVerify(email: string) {
        return this.post(`${this.serverUrl}/user/request-verify-token`, {email}, {}
        )
    }

    login(userInfo: any, contentType: string) {
        return this.post(`${this.serverUrl}/user/login`, userInfo, contentType)
    }
    logout(token: string) {
        return this.post(`${this.serverUrl}/user/logout`, {authToken: token}
        )
    }
    getCurrentUser(token: string) {
        return this.get(`${this.serverUrl}/user/me`, {authToken: token}
        )
    }
    getUserAvatar(avatar_id: string, resType: string) {
        return this.get(`${this.serverUrl}/user/avatar/storage/${avatar_id}`, {responseType: resType});
    }
    getUserById(token: string, id: string) {
        return this.get(`${this.serverUrl}/user/for_member/${id}`, {authToken: token})
    }
    getAllMentorList(token: string, filter?: string) {
        return this.get(`${this.serverUrl}/user?user_role=Mentor&size=250${filter ? filter : ''}`, {authToken: token})
    }
    getAllMemberList(token: string, filter?: string) {
        return this.get(`${this.serverUrl}/user?user_role=Member&size=250${filter ? filter : ''}`, {authToken: token})
    }
    getUserList(token: string, user_role: string, page: number, size:number, queryParam: string) {
        return this.get(`${this.serverUrl}/user?user_role=${user_role}&page=${page}&size=${size}${queryParam}`, {authToken: token})
    }
    /**
     * Server-side candidate search for the invite pickers.
     *
     * Built with URLSearchParams rather than the raw `filter` string the other
     * helpers take: a search term is user input, and `q=100%` or `q=a&b` would
     * otherwise corrupt the URL. An empty `q` is omitted, which the API treats
     * as "no filter" — that's the browse-the-first-page case.
     */
    searchUsers(token: string, user_role: string, q: string, size: number = 50) {
        const params = new URLSearchParams({user_role, size: String(size)})
        if (q && q.trim()) params.set('q', q.trim())
        return this.get(`${this.serverUrl}/user?${params.toString()}`, {authToken: token})
    }
    getUserListAdmin(token: string, queryParam: string) {
        return this.get(`${this.serverUrl}/user/admin/list_users${queryParam}`, {authToken: token})
    }
    getNotificationsList(token: string, page: number, size:number) {
        return this.get(`${this.serverUrl}/notification?pageNumber=${page}&pageSize=${size}`, {authToken: token})
    }
    getUnreadNotificationCount(token: string) {
        return this.get(`${this.serverUrl}/notification/unread-count`, {authToken: token})
    }
    markNotificationsSeen(token: string) {
        return this.post(`${this.serverUrl}/notification/seen`, {}, {authToken: token})
    }
    updateEditAuth(token: string, id: string, canEditArticle: boolean) {
        console.log("updateEditAuth used!!!", token, id, canEditArticle);
        return this.patch(`${this.serverUrl}/user/${id}/edit_article?can_edit_article=${canEditArticle}`, {}, {authToken: token});
    }
}